
export interface StoreReviewData {
  rating: number;
  reviewCount: number;
  lastUpdated: string;
}

export interface ReviewsData {
  averageRating: number;
  totalReviews: number;
  playStore: StoreReviewData;
  appStore: StoreReviewData;
}

// Données d'avis Allocab (mises à jour automatiquement via GitHub Actions)
const reviewsData: ReviewsData = {
  "averageRating": 4.7,
  "totalReviews": 9667,
  "playStore": {
    "rating": 4.660943984985352,
    "reviewCount": 2614,
    "lastUpdated": "2025-07-25"
  },
  "appStore": {
    "rating": 4.6756,
    "reviewCount": 7053,
    "lastUpdated": "2025-07-25"
  }
};

// Récupère les données d'avis Allocab
export function getReviewsData(): ReviewsData {
  return reviewsData;
}

// Calcule la note moyenne entre Play Store et App Store
export function calculateAverageRating(playStoreRating: number, appStoreRating: number): number {
  return Math.round(((playStoreRating + appStoreRating) / 2) * 10) / 10;
}

// Formate la note pour l'affichage (ex: 4.5)
export function formatRating(rating: number): string {
  return rating.toFixed(1);
}

// Formate le nombre d'avis avec séparateurs de milliers (ex: 75 589)
export function formatReviewCount(count: number): string {
  return count.toLocaleString('fr-FR');
}

// Génère les données structurées JSON-LD pour les avis (rich snippets Google)
export function generateReviewStructuredData(): object {
  const data = getReviewsData();
  
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Allocab",
    "url": process.env.NEXT_PUBLIC_APP_URL || "https://allocab.com",
    "description": "Réservez votre chauffeur privé VTC, taxi ou taxi-moto en quelques clics avec Allocab. Service de transport premium disponible dans toute la France.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": data.averageRating,
      "ratingCount": data.totalReviews,
      "reviewCount": data.totalReviews,
      "bestRating": 5,
      "worstRating": 1
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": data.playStore.rating,
          "bestRating": 5,
          "worstRating": 1
        },
        "author": { "@type": "Organization", "name": "Google Play Store" },
        "publisher": { "@type": "Organization", "name": "Google Play Store" }
      },
      {
        "@type": "Review", 
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": data.appStore.rating,
          "bestRating": 5,
          "worstRating": 1
        },
        "author": { "@type": "Organization", "name": "Apple App Store" },
        "publisher": { "@type": "Organization", "name": "Apple App Store" }
      }
    ]
  };
}
